import React, { createContext, useContext } from 'react';

interface ScrollContextValue {
  shouldShow: boolean;
}

const ScrollContext = createContext<ScrollContextValue | null>(null);

export const ScrollProvider: React.FC<{
  shouldShow: boolean;
  children: React.ReactNode;
}> = ({ shouldShow, children }) => {
  return (
    <ScrollContext.Provider value={{ shouldShow }}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  return context;
};
